import styled, { css } from "styled-components";

interface PropsButton {
  status: string;
  border?: boolean;
}

const normalizeStatus = (status: string) =>
  (status || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase();

const getStatusColor = (status: string) => {
  const normalizedStatus = normalizeStatus(status);

  if (normalizedStatus === "pendente") return "#9D54BB";
  if (normalizedStatus === "concluido") return "#51C4AF";
  if (normalizedStatus === "cancelado") return "#D9538D";
  if (normalizedStatus === "visualizar") return "#5178C4";
  if (normalizedStatus === "em_producao" || normalizedStatus === "em producao") {
    return "#F2A33B";
  }

  return "#6f7782";
};

export const Container = styled.button<PropsButton>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 40px;
  font-size: 1rem;
  font-weight: bold;
  white-space: nowrap;
  text-transform: capitalize;
  border: none;
  padding: 10px 40px;
  transition: filter 0.3s;
  cursor: pointer;
  &:hover {
    filter: brightness(0.9);
  }
  
  ${props => props.border && css`
  border-radius: 25px;
  `}
  
  background: transparent;
  
  color: ${props => getStatusColor(props.status)};


  border: 1px solid ${props => getStatusColor(props.status)};
`;
